import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import { initialOrderSubmissionContactType } from 'modules/client/common/forms/orderSubmissionContactsForm';
import { useFormContext } from 'modules/client/legal/forms/companyOrderSubmissionContactsForm';

import { FormContent } from './FormContent';

export const CompanyOrderSubmissionContactsSection = () => {
  const { t } = useTranslation();

  const { values, setFieldValue, readOnly } = useFormContext();

  const onAdd = () => {
    const orderSubmissionContacts = [
      ...values.orderSubmissionContacts,
      {
        type: initialOrderSubmissionContactType,
        value: '',
        firstName: '',
        lastName: '',
        position: '',
      },
    ];
    setFieldValue('orderSubmissionContacts', orderSubmissionContacts, false);
  };

  const onRemove = (index: number) => {
    const orderSubmissionContacts = [...values.orderSubmissionContacts];
    orderSubmissionContacts.splice(index, 1);
    setFieldValue('orderSubmissionContacts', orderSubmissionContacts, false);
  };

  return (
    <Section
      datax="companyOrderSubmissionContactsSection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAdd}
          />
        )
      }
      title={t('client.legal.companyOrderSubmissionContacts.title')}
    >
      <FormContent onRemove={onRemove} />
    </Section>
  );
};
